import { render, staticRenderFns } from "./NewEmail.vue?vue&type=template&id=7c38b2a4&scoped=true&"
import script from "./NewEmail.vue?vue&type=script&lang=js&"
export * from "./NewEmail.vue?vue&type=script&lang=js&"
import style0 from "./NewEmail.vue?vue&type=style&index=0&id=7c38b2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c38b2a4",
  null
  
)

export default component.exports